"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disposeObjectMap = disposeObjectMap;
exports.disposeArray = disposeArray;


/**
 * @private
 * destroy an object of disposable.
 * NB the object gets emptied as a way to help the GC.
 */


/**
 * An object with a `promise` and a `dispose` function to cancel the promise (making a pending promise to never ends).
 */
function disposeObjectMap(objmap) {
  for (var k in objmap) {
    if (objmap.hasOwnProperty(k)) {
      objmap[k].dispose();
      delete objmap[k];
    }
  }
}

/**
 * @private
 * destroy a array of disposable.
 * NB the array gets emptied as a way to help the GC.
 */

// Some utility for the disposable pattern

/**
 * @private
 * An object that have a dispose() function
 */
function disposeArray(arr) {
  var d = void 0;
  while (d = arr.pop()) {
    d.dispose();
  } // eslint-disable-line no-cond-assign
}
//# sourceMappingURL=disposable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/helpers/disposable.js
// module id = 47
// module chunks = 0